
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/organisations/[id]/[title]",
      function () {
        return require("private-next-pages/organisations/[id]/[title].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/organisations/[id]/[title]"])
      });
    }
  